import Link from "next/link";
import { AudienceSection } from "@/components/blocks/AudienceSection";

export function CtaBlock({ content }: { content: Record<string, unknown> }) {
  return (
    <AudienceSection content={content}>
      {(resolved) => {
        const heading = String(resolved.heading ?? "");
        const body = resolved.body ? String(resolved.body) : "";
        const primary = resolved.primaryButton as { text?: string; url?: string } | undefined;
        const secondary = resolved.secondaryButton as { text?: string; url?: string } | undefined;
        const tone = String(resolved.tone ?? "saas");
        const approachable = tone === "approachable";

        return (
          <section
            className={
              approachable
                ? "bg-[var(--color-surface-muted)] py-12"
                : "bg-[var(--color-primary)] py-12 text-white"
            }
          >
            <div
              className={`mx-auto flex max-w-6xl flex-col gap-4 px-4 ${
                approachable ? "items-start text-left" : "items-center text-center"
              }`}
            >
              <h2 className={`text-2xl font-bold md:text-3xl ${approachable ? "text-[var(--color-text)]" : ""}`}>
                {heading}
              </h2>
              {body && (
                <p className={`max-w-2xl text-lg ${approachable ? "text-[var(--color-secondary)]" : "opacity-90"}`}>
                  {body}
                </p>
              )}
              <div className="flex flex-col gap-3 sm:flex-row">
                {primary?.text && primary?.url && (
                  <Link
                    href={primary.url}
                    className={
                      approachable
                        ? "inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] bg-[var(--color-text)] px-6 py-2 text-sm font-medium text-[var(--color-surface)]"
                        : "inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] bg-white px-6 py-2 text-sm font-medium text-[var(--color-primary)]"
                    }
                  >
                    {primary.text}
                  </Link>
                )}
                {secondary?.text && secondary?.url && (
                  <Link
                    href={secondary.url}
                    className={
                      approachable
                        ? "inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] border border-[var(--color-border)] px-6 py-2 text-sm font-medium text-[var(--color-text)]"
                        : "inline-flex min-h-[44px] items-center justify-center rounded-[var(--border-radius)] border border-white px-6 py-2 text-sm font-medium text-white"
                    }
                  >
                    {secondary.text}
                  </Link>
                )}
              </div>
            </div>
          </section>
        );
      }}
    </AudienceSection>
  );
}
